export default __webpack_public_path__ + "static/media/Relikof-Kidz-ban.b153357f.jpg";